import React from 'react'
import {Helmet} from "react-helmet";
import PageTitle from '../../pagetitle/PageTitle'
import KoordinasyonKurulu from '../../kurullar/KoordinasyonKurulu'

export default function Koordinasyon()
{
    const title = "OKAF Koordinasyon Kurulu - Samsun Üniversitesi";
    const description = "Samsun Üniversitesi ev sahipliğinde gerçekleşecek olan Orta Karadeniz Kariyer Fuarı (OKAF)'ın koordinasyon kurulu hakkında ayrıntılı bilgi için tıklayınız!";
    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />
            </Helmet>
            <PageTitle name="Koordinasyon Kurulu"></PageTitle>
            <KoordinasyonKurulu></KoordinasyonKurulu>
        </>
    )
}
